import React from 'react';
import './CheckBox.scss';

const CheckBox = ({ label, checked, onChange, value, dataTest }) => {
  return (
    <div className='checkbox-wrapper'>
      <input className='checkbox-wrapper__box' type='checkbox' checked={checked} value={value} onChange={onChange} data-test={dataTest} />
      <label>{label}</label>
    </div>
  );
};

export default CheckBox;
